import React from "react";

/**
 * Filter side panel overlay — self-contained structure and class names.
 * No dependency on global .dropdownList / .filterSliderContent styles.
 */
const FilterPanelOverlay = ({ title, onClear, onClose, clearLabel = "Clear", showClear = false, children, helpContent, panelClassName }) => {
  return (
    <div className={`filter-panel${panelClassName ? ` ${panelClassName}` : ""}`}>
      <div className="filter-panel__header">
        <span className="filter-panel__title">{title}</span>
        <div className="filter-panel__actions">
          {showClear && (
            <button type="button" className="filter-panel__clear" onClick={onClear} aria-label="Clear selection">
              {clearLabel}
            </button>
          )}
          <button
            type="button"
            className="filter-panel__done"
            onClick={onClose}
            aria-label="Done"
          >
            Done
          </button>
        </div>
      </div>
      <div className="filter-panel__body">
        {children}
        {helpContent && <div className="filter-panel__field-hint">{helpContent}</div>}
      </div>
    </div>
  );
};

export default FilterPanelOverlay;
